import Skeleton from "@/components/loadings/skeleton/Skeleton";

export function GroupUserRowSkeleton() {
  return (
    <div className="flex items-center gap-3 px-6 py-2">
      <div className="size-12 shrink-0 rounded-full bg-gray-200" />
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <Skeleton size="sm" className="w-32" fixed={false} />
        <Skeleton size="xs" className="w-24" fixed={false} />
      </div>
    </div>
  );
}

export function GroupSettingsSkeleton() {
  return (
    <div className="flex h-full flex-col bg-white">
      <div className="flex items-center gap-3 border-b px-6 py-4">
        <div className="size-10 shrink-0 rounded-lg bg-gray-200" />
        <Skeleton size="lg" className="w-24 flex-1" fixed={false} />
        <div className="size-10 shrink-0 rounded-lg bg-gray-200" />
        <div className="size-10 shrink-0 rounded-lg bg-gray-200" />
      </div>
      <div className="flex items-center gap-3 px-6 py-4">
        <div className="size-12 shrink-0 rounded-full bg-gray-200" />
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton size="lg" className="w-40" fixed={false} />
          <Skeleton size="sm" className="w-20" fixed={false} />
        </div>
      </div>
      <div className="h-10 bg-gray-50" />
      <div className="p-6">
        <Skeleton size="sm" className="w-28" fixed={false} />
      </div>
      <div className="mx-6 h-px bg-gray-200" />
      <div className="p-6">
        <Skeleton size="sm" className="w-32" fixed={false} />
      </div>
      <div className="flex-1 space-y-1 pt-2">
        {[...Array(5)].map((_, index) => (
          <GroupUserRowSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}

export function GroupEditSkeleton() {
  return (
    <div className="flex h-full flex-col bg-white">
      <div className="flex items-center gap-3 border-b px-6 py-4">
        <div className="size-10 shrink-0 rounded-lg bg-gray-200" />
        <Skeleton size="lg" className="w-16 flex-1" fixed={false} />
        <div className="size-10 shrink-0 rounded-lg bg-gray-200" />
      </div>
      <div className="flex items-center gap-3 px-6 pt-4">
        <div className="size-24 shrink-0 rounded-full bg-gray-200" />
        <Skeleton size="2xl" className="h-11 flex-1 rounded-lg" fixed={false} />
      </div>
      <div className="h-10 bg-gray-50" />
      {[...Array(3)].map((_, index) => (
        <div key={index}>
          <div className="flex items-center justify-between px-6 py-4">
            <Skeleton size="sm" className="w-20" fixed={false} />
            <Skeleton size="sm" className="w-8" fixed={false} />
          </div>
          {index < 2 && <div className="mx-6 h-px bg-gray-200" />}
        </div>
      ))}
    </div>
  );
}
